<template>
  <div class="Carousel">
    <el-carousel :interval="4000" arrow="always">
      <el-carousel-item v-for="item in dataList" :key="item">
        <img @click="dialogVisible = true"
          class="img-banner"
          :src="item.url"
          alt=""
          style="margin-top: 3%;width: 100%; height: 100%; object-fit: contain; display: block"
        />
      </el-carousel-item>
    </el-carousel>
    <el-dialog
        title="Please contact us"
        :visible.sync="dialogVisible"
        width="20%">
      <div class="demo-image__placeholder">
        <a href="https://wa.me/+8613552714703" target="_blank">
          <el-image style="width: 60px; margin-left: 40px" :src="src1"></el-image>
        </a>
        <a href="https://t.me/+919731548743" target="_blank">
          <el-image style="width: 60px; margin-left: 40px" :src="src2"></el-image>
        </a>
        <a href="https://join.skype.com/invite/cnp39jm4FcFl" target="_blank">
          <el-image style="width: 60px; margin-left: 40px" :src="src3"></el-image>
        </a>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import src1 from "../../../src/assets/img/wa.png";
import src2 from "../../../src/assets/img/te.png";
import src3 from "../../../src/assets/img/sk.png";
export default {
  name: 'Carousel',
  props: {
    dataList: Array,
    default: () => {
      return []
    }
  },
  data() {
    return {
      dialogVisible: false,
      src1,
      src2,
      src3
    }
  },
  methods: {
    goToRegist() {
      // this.$router.push('/CONTACT')
    },
  }
}
</script>

<style lang="scss" scoped>
@media screen and  (min-width: 769px) {
  .img-banner {
    transform: scale(1.2);
  }
  .Carousel {
    width: 100%;
    height: 6rem;
    display: flex;
    background-color: rgba(230, 242, 234, 1);
  }
  ::v-deep .el-carousel {
    width: 100%;
    height: 105%;
  }
  ::v-deep .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  ::v-deep .el-carousel__container {
    position: relative;
    height: 100%;
  }
  ::v-deep .el-carousel__item:nth-child(2n) {
    background-color: #e6f2ea;
  }

  ::v-deep .el-carousel__item:nth-child(2n + 1) {
    background-color: #e6f2ea;
  }
}
@media only screen and (max-width: 768px) {
  .img-banner {
    transform: scale(1.1);
  }
  .Carousel {
    width: 100%;
    height: 4rem;
    display: flex;
  }
  ::v-deep .el-carousel {
    width: 100%;
    height: 100%;
  }
  ::v-deep .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  ::v-deep .el-carousel__container {
    position: relative;
    height: 100%;
  }
  ::v-deep .el-carousel__item:nth-child(2n) {
    // background-color: #99a9bf;
  }

  ::v-deep .el-carousel__item:nth-child(2n + 1) {
    // background-color: #d3dce6;
  }
}
</style>
